import { SearchBookField } from './SearchBookField'
import { withSearchBookField } from './withSearchBookField'

const ConnectedSearchBookField = withSearchBookField(SearchBookField)

export { ConnectedSearchBookField as SearchBookField }
